import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { FunctionComponent } from "react";

import { Icon } from "@/components";
import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { classNames } from "@/utils/classNames";

interface SubscriptionCardProps {
	name: string;
	description: string;
	creditsLabel: string;
	monthlyPrice: number;
	features: string[];
	variant: "default" | "featured";
	selectTitle: string;
	includedTitle: string;
	perMonth: string;
	onSelect: () => void;
}

export const SubscriptionCard: FunctionComponent<SubscriptionCardProps> = ({
	name,
	description,
	creditsLabel,
	monthlyPrice,
	features,
	variant = "default",
	selectTitle,
	includedTitle,
	perMonth,
	onSelect,
}) => {
	return (
		<div
			className={classNames(
				"max-w-[350px] flex flex-col text-left justify-start items-start drop-shadow-md rounded-xl p-8 ",
				variant === "default" ? "bg-white text-black-100" : "bg-blue-action text-white"
			)}
		>
			<div className="text-md font-[900] mb-4">{name}</div>
			<div className="text-ssm mb-4">{description}</div>
			<div
				className={classNames(
					"mb-4 text-lg font-extrabold",
					variant === "default" ? "text-blue-action" : "text-white"
				)}
			>
				€{monthlyPrice}
				<span
					className={classNames(
						"text-smd font-normal",
						variant === "default" ? "text-black-100" : "text-white"
					)}
				>
					{perMonth}
				</span>
			</div>

			<div
				className={classNames(
					"text-smd mb-4",
					variant === "default" ? "text-black-100" : "text-white"
				)}
			>
				{creditsLabel}
			</div>

			<div
				className={classNames(
					"mb-4 text-smd",
					variant === "default" ? "text-blue-action font-extrabold" : "text-white"
				)}
			>
				{includedTitle}
			</div>
			<div className="w-full mb-4">
				{features.map((feature) => (
					<div key={feature} className="flex flex-row items-center mb-2 text-sm">
						<div className="bg-secondary-item rounded-full w-5 h-5 flex justify-center items-center mr-3">
							<Icon className="text-blac-100 w-3 h-3" icon={faCheck} />
						</div>
						{feature}
					</div>
				))}
			</div>
			<Button
				color={variant === "default" ? ButtonColor.ACTION : ButtonColor.ACTION_SECONDARY}
				size={ButtonSize.ML}
				title={selectTitle}
				onClick={onSelect}
			/>
		</div>
	);
};
